export interface CreateLocationDto {
  addressLine1: string; // Required, max 255 characters
  addressLine2?: string | null; // Optional, max 255 characters
  city: string; // Required, max 100 characters
  stateCode: string; // Required, max 2 characters
  zipCode: string; // Required, max 10 characters
}
